import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaSearch } from 'react-icons/fa';
import SEO from '../components/SEO';
import AppSidebar from '../components/common/AppSidebar';
import '../styles/layouts/NotFoundPage.scss';

const NotFoundPage = () => {
  // Set data-page attribute on body for CSS targeting to match homepage style
  useEffect(() => {
    document.body.setAttribute('data-page', 'home');
    
    return () => {
      document.body.removeAttribute('data-page');
    };
  }, []);
  
  return (
    <>
      <SEO 
        fallbackTitle="Page Not Found - Zahoot"
        fallbackDescription="The page you are looking for could not be found."
      />
      <div className="home-page">
        {/* Sidebar Navigation */}
        <AppSidebar />
        
        <main className="home-page__main">
          <div className="max-w-6xl w-full px-4 lg:right-9 sm:px-6 lg:px-8 mx-auto z-10 relative">
            
            {/* Hero Section with Gradient Background */}
            <div className="text-center mb-12 z-10 relative pt-20">
              <h1 className="text-5xl md:text-6xl font-bold mb-6 text-white">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D80364] to-[#F0654B] text-error-pulse">404</span> Page Not Found
              </h1>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                The page you are looking for does not exist or has been moved.
              </p>
            </div>
            
            <div className="flex flex-col md:flex-row gap-6 justify-center items-center mt-10 z-10 relative">
              <Link 
                to="/" 
                className="btn btn--primary btn--lg flex items-center"
                style={{background: 'linear-gradient(92.68deg, #D80364 0%, #F0654B 100%)'}}
              >
                <FaHome className="mr-2 text-xl" />
                Back to Home
              </Link>
              <Link 
                to="/search" 
                className="btn btn--outline btn--lg flex items-center"
              >
                <FaSearch className="mr-2 text-xl" />
                Search Solicitors
              </Link>
            </div>
          
            {/* Not Found Illustration */}
            <div className="py-20 mt-20 z-10 relative">
              <div className="max-w-md mx-auto">
                <div className="p-8 bg-purple-900/50 rounded-xl shadow-sm transition-all duration-300 hover:shadow-lg">
                  <div className="w-20 h-20 bg-purple-500/30 rounded-full flex items-center justify-center mb-6 mx-auto">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-purple-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-center mb-4 text-white">Lost your way?</h3>
                  <p className="text-gray-300 text-center mb-4">
                    Don't worry, it happens to the best of us. You can use the navigation above to find what you're looking for.
                  </p>
                  <p className="text-gray-300 text-center">
                    If you believe this is an error, please <Link to="/contact" className="text-[#F0654B] hover:underline">contact support</Link>.
                  </p>
                </div>
              </div>
            </div>
            
          </div>
        </main>
      </div>
    </>
  );
};

export default NotFoundPage; 